import React, { useState } from 'react';
import styled from "styled-components"; 
import WelcomeBody from './WelcomeBody';
import ActionItem from '../ActionItem';
import getImg from '../../../Utils/getImg.js';
import isInsignia from '../../../Utils/IsInsignia';
import WorkflowsMenu from '../../BaseComponents/WorkflowsMenu';
import Carousel from './CarouselRBL';
import Axios from 'axios';
import {wrapperEndPoint} from "../../../Utils/Api";
import QuickLinks from './QuickLinks';
import newYearTheme2 from '../../../../assets/imgs/welcomeScreen/ThemeRbl/2023_background.gif';
import newYearTheme1 from '../../../../assets/imgs/welcomeScreen/ThemeRbl/2023_background_1.gif';
const CustomWelcomeBody = styled(WelcomeBody)`
	background: #fff;
	color: #000;
	padding : 0;
	overflow : auto;
    /*z-index: 2;*/
    
    .content-library-link {
        color: #2c387a;
        /* width: 100%; */
        padding: 6px 8px;
        text-decoration: none;
        border: 1px solid #da3b26;
        border-radius: 4px;
        margin-right: 40px;
        font-size: 13px;
        font-weight: normal;
    }
    @media only screen and (max-width: 340px) {
        .content-library-link{
            margin-right: 20px;
        }
    }
`

//props.data.primaryColor ? props.data.primaryColor : "#0267f0"

const WelcomeText = styled.div`
	font-size: 14px;
	background: ${props => {
        return isInsignia() ? '#070d44' :  'radial-gradient(circle at 100% 130%, #ae0105, #2e0202)' // `url(${newYearTheme1})` 
    }};
    color: #fff;
    // margin-bottom: 30px;
    // padding: 20px 30px 35px 30px;
    margin-bottom: 4%;
    padding: 1% 7%;
    /* border-bottom-left-radius: 80px; */
    & div{
        font-size : 26px;
        font-weight : 500;
	}
    min-height: ${props => props.newYear ? '150px' : ''}; 

    padding-bottom: ${props => props.mycardApp ? '50px' : '24px'}; 
    margin-bottom: ${props => props.mycardApp ? '16px' : '-20px'};
    //  padding-bottom:80px; //here  //40px mobankApp and mycardApp
    //  margin-bottom:-20px;//here    //16px
     
    
`
//added css
const CarouselBody = styled.div`

width:100%
margin-bottom:5px;
margin-top:-48px;


`
const QuickLinksBody = styled.div `

display:block;
`

const QuickLinksBlock = styled.div`
    

    display : -webkit-box;
    display : -ms-flexbox;
    display : flex;
    -webkit-box-orient : horizontal;
    -webkit-box-direction : normal;
    -ms-flex-flow : row wrap;
    flex-flow : row wrap;

    padding: 6% 2%;
    padding-bottom: 0%;
    position: static;
   

`

const FlexIcon = styled.div`
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
        justify-content:center;
    -webkit-box-align: center;
    -ms-flex-align: center;
        align-items: center;

    width:65%;
    height:65%;

    margin-bottom: 10px;
    cursor:pointer;
    position: relative;

    // @media only screen and (min-width: 768px) and (max-width: 959px){
    //     & {
    //      width:60px;
    //      height:60px;
    //     }
    // }
`

const CustomQuickLink = styled.div`
    display : -webkit-box;
    display : -ms-flexbox;
    display : flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align:center;
        -ms-flex-align:center;
            align-items:center;
    width : calc( 33.33% - ${80 / 6}px);

	margin-right: ${80 / 6}px;

        margin-bottom: 5%;
    position: relative;

 
    //here
    .special-text{
        color: #2c387a !important;
        font-weight: 600;
    }
    .rotate {
        -webkit-animation: anim 3.5s infinite linear;
           animation: anim 3.5s infinite linear;
       }
       
       @-webkit-keyframes anim {
        //  from {-webkit-transform: rotateY(0deg);}
        //  to {-webkit-transform: rotateY(360deg);}
            0% {transform: rotateY(0deg);}
            50% {transform: rotateY(90deg);}
            50.1% {transform: rotateY(270deg);}
            100% {transform: rotateY(360deg);}
       }
       
       @keyframes anim {
        // from {-webkit-transform: rotateY(0deg);}
        // to {-webkit-transform: rotateY(360deg);}
           0% {transform: rotateY(0deg);}
           50% {transform: rotateY(90deg);}
           50.1% {transform: rotateY(270deg);}
           100% {transform: rotateY(360deg);}
       }
       
       .new-quicklink {
        position: absolute;
        left: 78%;
        font-size: 12px;
        top: 0;
        color: red;
        padding: 6px;
        font-weight: 600;
        border-radius: 18px;
        
     
    }


	${FlexIcon}:hover{
		/* background : #00dc94; */

		& svg{
			fill : #fff;
			animation : none;
		}
	}

	&& div:last-child, && a:last-child{
		font-size : 12px;
		color: #666;
		border: 0 !important;
		border-radius : 0;
		background : transparent !important;
		margin : 0;
		padding:0;
	}

	&& > div:last-child:hover, && a:last-child:hover{
		background : transparent;
		color: #959191;
		animation : none;
	}
`
const quickLinks = [
    {
        actionLabel: "Offers",
        actionValue: "Offers"
    },
    {
        actionLabel: "My Account",
        actionValue: "My Account"
    },
    {
        actionLabel: "Apply",
        actionValue: "Apply"
    },
    {
        actionLabel: "Interest Rates",
        actionValue: "Interest Rates"
    },
    {
        actionLabel: "Secure Banking",
        actionValue: "Secure Banking"
    },
    {
        actionLabel: "Block Card",
        actionValue: "Block Card"
    }
]





const ThemeRbl = (props) => {

    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [menuIndex, setMenuIndex] = useState(0);//
    



    const toggleMenu = () => {
       setIsMenuVisible(isMenuVisible => !isMenuVisible);
    } 

    const handleMenu = (actionLabel ,actionType, index) => {

        if(actionType === "menu"){
           
            
            toggleMenu();
            setMenuIndex(index);
            
        }
        else{null}
    
    }

    const sendAnalyticsforQuickLink = (data)=> {

        let analyticsData = {name:data,type:'Quick Link' ,action:"",botid: "vYdoWvH2CVMbJOGnAB11VA=="}
   
         Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
       
         .then(response => {
             console.log(response);//handle sucess
         }).catch(error => {
             console.log(error);//handle error
         });
     
     }

    if (!props.showWelcomeScreen) {
        return null;
    }
    return (
       
        <CustomWelcomeBody {...props}>
            <WelcomeText {...props} className={props.newYear? 'new-year-theme': 'normal'} >
                {
                    // !!props.data.welcomeMessage ? 
                    // props.data.welcomeMessage
                    // : 
                    <React.Fragment>
                        <div className={` ${props.animateHeader?  'sf-new-year-welcome': ''}`}     style={{paddingBottom: "10px",marginTop: "10px",fontSize: "16px"}}>
                            Hi there!
					    </div>

                    {props.newYear ? <div className={`new-year-msg  ${props.animateWish== true ? 'morbid': ''}`} >Happy New Year 2023</div> : null}
                    {props.newYear ? <div className={` ${props.animateMsg?  'sf-new-year-welcome': ''}`}  style={{fontSize: "14px" , display: 'none', marginTop: '10px'}}>{props.data.welcomeMessage &&
                            props.data.welcomeMessage}</div> : props.data.welcomeMessage &&
                                props.data.welcomeMessage} 

                    
                    </React.Fragment>
                }
                
            </WelcomeText>

            {/* {window.location.href.includes('pb/RBLCares') || window.location.href.includes('pb/') || props.mycardApp?  
            null :  
                    <CarouselBody>
                <Carousel></Carousel>
                    </CarouselBody> } */}

         
           
{/* 
            <div style={{ color: '#666666', fontWeight: '500', fontSize: "14px", paddingLeft: "40px",display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:"30px"}}>
                <div style={{maxWidth:'50%'}}>
                    How can I help you today?
                     <div style={{ fontWeight: 'normal', marginTop: '3px' }}>
                        Get started by asking
                    </div> 
                </div>
               
                <div>
                   <a className="content-library-link" href={window['SF_CONTENT_URL']} target="_blank" rel="noopener noreferrer">Content Library</a>
                </div>

            </div> */}

        <QuickLinksBody> 
            <QuickLinksBlock>

                
                <QuickLinks
                  handleSubmit={props.handleSubmit}
                  handleJustUIPrintCall={props.handleJustUIPrintCall}
                  addServerResponse={props.addServerResponse}
                  showWelcomeScreen={props.showWelcomeScreen}
                  hideWelcomeScreen={props.hideWelcomeScreen}
                /> 


                {/* {
                    props.quickLinks.map((e, i) => {
                        if(e.actionLabel==="Content Library"){
                            return null;
                        }
                        return (
                            <CustomQuickLink key={i} onClick={e.actionType === "menu" ? toggleMenu : null}>
                                 <FlexIcon onClick={event => event.currentTarget.nextSibling.click()}>
                                    {(i==4 || i==2)?<span className='new-quicklink'>New</span>:null}
                    
                                    <img style={{width:"60px",height:"60px"}} className={i==1?'rotate':''} src={getImg(`welcomeScreen/ThemeRbl/${i + 1}${isInsignia() ? '-i' : ''}.svg`)} alt="" />
                                </FlexIcon> */}
                                <div style={{visibility: "hidden",position: "fixed"}}>
                                <ActionItem  
                                // listElemClass={(i==1 || i==2 || i==4)?'special-text':''} 
                                //     onClick={()=>{handleMenu(e.actionLabel, e.actionType, e.menuIndex); sendAnalyticsforQuickLink(e.actionLabel)}}
                                //     actionLabel={e.actionLabel}
                                //     actionValue={e.actionValue}
                                //     actionType={e.actionType}
                                    handleSubmit={props.handleSubmit}
                                    handleQuickLinkSubmit={props.handleQuickLinkSubmit}
                                    >        
                                </ActionItem>
                                </div>
                            {/* </CustomQuickLink>
                        )
                    }) 
                }
                <WorkflowsMenu from={'bottom'} workflowQuestions={props.data.workflowQuestions} isMenuVisible={isMenuVisible} toggleMenu={toggleMenu} menuIndex={menuIndex}/>
            */}
            </QuickLinksBlock>
        </QuickLinksBody>
    
        </CustomWelcomeBody>
    );
}


export default ThemeRbl;
// onClick={e.actionType === "menu"? toggleMenu: null}